module.exports = __webpack_public_path__ + "img/three-step-mobile.d62d13b.png";